module.exports = __webpack_public_path__ + "15a08341a0f956a9d95fde6bf9924146.svg";